import { ReactElement, useMemo } from 'react';

import { StaticDataConfiguration, Table } from '@dreryk/react-components';

import { CopiedPrescription, NotCopiedPrescriptionSummaryItem } from '../copyPrescription.types';

import { useCopySummaryTableColumns } from './CopySummaryTable.hooks';
import { CopySummaryRow } from './CopySummaryTable.types';
import { mapToRows } from './CopySummaryTable.utils';

type CopySummaryTableProps = {
   readonly copiedPrescriptions: CopiedPrescription[];
   readonly notCopiedSummaryItems: NotCopiedPrescriptionSummaryItem[];
   readonly onReplace: (item: NotCopiedPrescriptionSummaryItem) => void;
};

export const CopySummaryTable = (props: CopySummaryTableProps): ReactElement => {
   const rows = useMemo(() => mapToRows(props.copiedPrescriptions, props.notCopiedSummaryItems), [
      props.copiedPrescriptions,
      props.notCopiedSummaryItems,
   ]);

   const dataConfiguration = useMemo<StaticDataConfiguration<CopySummaryRow>>(() => ({ data: rows }), [rows]);

   const columns = useCopySummaryTableColumns({
      onReplace: props.onReplace,
      notCopiedSummaryItems: props.notCopiedSummaryItems,
   });

   return (
      <Table<CopySummaryRow>
         columns={columns}
         dataConfiguration={dataConfiguration}
         keyExtractor={'id'}
         testId={'copySummaryTable'}
      />
   );
};
